export const APP_READ = 'app:read'

export const ANTIFRAUD = {
  DELETE: 'antifraud_label:delete',
  READ: 'antifraud_label:read',
  UPDATE: 'antifraud_label:update',
  WRITE: 'antifraud_label:write'
}

export const ANTIFRAUD_LISTS = {
  DELETE: 'antifraud_lists:delete',
  READ: 'antifraud_lists:read',
  UPDATE: 'antifraud_lists:update',
  WRITE: 'antifraud_lists:write'
}

export const ANTIFRAUD_RULES = {
  DELETE: 'antifraud_rules:delete',
  READ: 'antifraud_rules:read',
  UPDATE: 'antifraud_rules:update',
  WRITE: 'antifraud_rules:write'
}

export const DASHBOARD = {
  READ: 'dashboards:read'
}

export const PARTNERS = {
  READ: 'app:read'
}

export const ORDERS = {
  READ: 'orders:read'
}
